import clsx from 'clsx';
import dayjs, { Dayjs } from 'dayjs';
import { default as Picker } from 'react-datepicker';

interface IDatePickerProps {
  onChange?: (date: Dayjs) => void;
  selectedDate?: Dayjs;
  minDate?: Dayjs;
  maxDate?: Dayjs;
  isReadOnly?: boolean;
  isFixedSize?: boolean;
  className?: string;
  wrapperClassName?: string;
}

export const DatePickerInput = (props: IDatePickerProps) => {
  return (
    <Picker
      selected={props.selectedDate?.toDate()}
      onChange={(dates) => props.onChange && props.onChange(dayjs(dates))}
      startDate={props.minDate?.toDate()}
      endDate={props.maxDate?.toDate()}
      readOnly={props.isReadOnly}
      dateFormat={'dd.MM.yyyy'}
      wrapperClassName={props.wrapperClassName}
      className={clsx('bg-ice dark:bg-eerie-black !border-b-light py-2 px-3', props.className ?? '')}
    />
  );
};
